import React from "react";
import { connect } from "react-redux";

import { ContentWrapper } from "../components/Nav";
import { PaymentSelect } from "../components/Select";
import { MasonryLayout, MasonryItem } from "../components/Masonry/Masonry";
import { logout } from "../actions/auth";
import { IOSToggle } from "../components/Toggle/IOSToggle";
import { AddButton } from "../components/Button";
import "./styles/Account.scss";

const paymentMethods = [
  { name: "Chase College", isDefault: true, bank: "Chase", last4digits: "0496" }
];

class Account extends React.Component {
  constructor(props) {
    super(props);

    const { email, phone } =
      (this.props.userData && this.props.userData.account) || {};

    this.state = {
      email: email || "",
      phone: phone || ""
    };
  }

  render() {
    return (
      <ContentWrapper style={{ display: "flex", flexDirection: "column" }}>
        <div id="accountContent">
          <div className="paymentHeader">
            <h3>Funding Source</h3>
            <AddButton onClick={() => alert("add funding source")}>
              ADD FUNDING SOURCE
            </AddButton>
          </div>
          <PaymentSelect paymentMethods={paymentMethods} />

          <h3 className="accountSettings">Account Settings</h3>
          <MasonryLayout>
            <MasonryItem>
              <div className="itemSection bottomBorder">
                <h4>LOGIN DETAILS</h4>
              </div>
              <div className="itemSection bottomBorder">
                <p>{this.state.email}</p>
              </div>
              <div className="itemSection">
                <p className="passStyle">••••••••</p>
              </div>
            </MasonryItem>
            <MasonryItem>
              <div className="itemSection showInline">
                <h4 style={{ flex: 1 }}>NOTIFICATIONS</h4>
                <IOSToggle />
              </div>
              <div className="itemSection" style={{ paddingTop: 0 }}>
                <p>Get notifications when your shipments arrive.</p>
              </div>
            </MasonryItem>
            <MasonryItem>
              <div className="itemSection bottomBorder">
                <h4>PHONE</h4>
              </div>
              <div className="itemSection">
                <p>{this.state.phone}</p>
              </div>
            </MasonryItem>
          </MasonryLayout>
        </div>
      </ContentWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout())
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Account);
